import { render, staticRenderFns } from "./BlocTaches.vue?vue&type=template&id=2411cee6&"
import script from "./BlocTaches.vue?vue&type=script&lang=js&"
export * from "./BlocTaches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports